import { Link, useNavigate } from "react-router-dom";
import { Shield, Menu } from "lucide-react";
import { useState } from "react";
import { useLang } from "@/context/LangContext";
import { useAuth } from "@/context/AuthContext";
import { LangToggle } from "@/components/LangToggle";

export const CitizenHeader = () => {
  const { t } = useLang();
  const { user } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="ashoka-stripe" />
      <header className="sticky top-0 z-40 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <div className="w-10 h-10 rounded-md bg-[#0A3161] flex items-center justify-center">
              <Shield className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500">{t("govOfHaryana")}</div>
              <div className="font-heading font-bold text-sm sm:text-base text-slate-900 leading-none">{t("appName")}</div>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-7 text-sm">
            <Link to="/" className="text-slate-700 hover:text-[#0A3161]">{t("home")}</Link>
            <Link to="/grievance/new" className="text-slate-700 hover:text-[#0A3161]" data-testid="nav-grievance">{t("grievance")}</Link>
            <Link to="/track" className="text-slate-700 hover:text-[#0A3161]" data-testid="nav-track">{t("track")}</Link>
          </nav>

          <div className="flex items-center gap-2">
            <LangToggle />
            {user ? (
              <button
                onClick={() => nav("/dashboard")}
                data-testid="goto-dashboard"
                className="hidden sm:inline-flex items-center px-3 py-2 text-xs font-semibold rounded-md text-white"
                style={{ background: "#0A3161" }}
              >
                {t("dashboard")}
              </button>
            ) : (
              <button
                onClick={() => nav("/login")}
                data-testid="header-login-btn"
                className="hidden sm:inline-flex items-center px-3 py-2 text-xs font-semibold rounded-md text-white"
                style={{ background: "#0A3161" }}
              >
                {t("login")}
              </button>
            )}
            <button onClick={() => setOpen(!open)} className="md:hidden p-2"><Menu className="w-5 h-5" /></button>
          </div>
        </div>
        {open && (
          <div className="md:hidden border-t border-slate-200 px-4 py-3 space-y-2 bg-white">
            <Link to="/" className="block text-sm">{t("home")}</Link>
            <Link to="/grievance/new" className="block text-sm">{t("grievance")}</Link>
            <Link to="/track" className="block text-sm">{t("track")}</Link>
            <Link to="/login" className="block text-sm">{t("login")}</Link>
          </div>
        )}
      </header>
    </>
  );
};
